import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'

export default class Generic extends HObject {
  constructor (hObject) {
    super(hObject.name, hObject.type, hObject.allowRegistration)
    this.init(hObject)
  }

  register () {
    let hObject = this
    this.registered = true

    BABYLON.SceneLoader.ImportMesh('', 'static/assets/Generic/' + hObject.type + '/', hObject.type + '.babylon', window.scene, function (newMeshes, particleSystems) {
      hObject.objectConfigurations(newMeshes)
      hObject.lod(newMeshes)
    })
  }
}



// WEBPACK FOOTER //
// ./src/hobjects/Generic.js